// BCM-898 · Goods Receipt Dashboard — shared shell for every inline Action section.
// Renders a header row (title + optional warning icon + badge on the left, action
// buttons on the right), an optional sub-text, then the section body. When
// `viewOnly` is true the whole section is dimmed and controls are disabled
// (doc rev V2 — the section still renders; only its controls are disabled). This is
// the wrapper the CMO always gets (Goods Receipt is view-only for CMO).
import React from "react";
import { Typography } from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import { useGRStyles } from "../goodsReceiptStyles";

const SectionShell = ({ title, subText, badge, badgeSuccess, warn, headRight, viewOnly, children }) => {
  const classes = useGRStyles();
  return (
    <div
      className={classes.section}
      style={viewOnly ? { opacity: 0.7, pointerEvents: "none" } : undefined}
      aria-disabled={viewOnly ? true : undefined}
    >
      {viewOnly && (
        <Typography variant="caption" className={classes.viewOnlyNote}>
          View only — you do not have access to perform this action.
        </Typography>
      )}
      <div className={classes.sectionHeadRow}>
        <div>
          {title && (
            <Typography className={classes.sectionTitle}>
              {warn && <WarningRoundedIcon style={{ color: "#C0392B", fontSize: 20 }} />}
              {title}
              {badge != null && badge !== "" && (
                <span className={badgeSuccess ? classes.badgeSuccess : classes.badge}>{badge}</span>
              )}
            </Typography>
          )}
        </div>
        {headRight && <div className={classes.btnRow}>{headRight}</div>}
      </div>
      {subText && <Typography className={classes.sectionSub}>{subText}</Typography>}
      {children}
    </div>
  );
};

export default SectionShell;
